import {
  createEnterpriseResponseSchema,
  getEnterprisesResponseSchema,
  type GetEnterprisesResponse,
  UpdateEnterpriseSettingsBody,
} from "@mg/schemas/src/christo/catalyst";

import { API_URL } from "../config/env";
import { smartFetch, handleApiError } from "../utils/http";

export async function createEnterprise(name: string) {
  const requestUrl = `${API_URL}/private/catalyst/internal/enterprises`;
  const json = await smartFetch(requestUrl, {
    method: "POST",
    body: JSON.stringify({ name }),
  });

  return createEnterpriseResponseSchema.parse(json);
}

export async function getEnterprises(): Promise<GetEnterprisesResponse> {
  const requestUrl = `${API_URL}/private/catalyst/enterprises`;
  const json = await smartFetch(requestUrl);

  try {
    return getEnterprisesResponseSchema.parse(json);
  } catch (error) {
    console.error(error);
    return json as GetEnterprisesResponse;
  }
}

export async function updateEnterpriseSettings(
  payload: UpdateEnterpriseSettingsBody,
) {
  const json = await smartFetch(
    `${API_URL}/private/catalyst/enterprises/settings`,
    {
      method: "PUT",
      body: JSON.stringify({
        ...payload,
      }),
    },
  );

  const parsedData = createEnterpriseResponseSchema.parse(json);
  return parsedData;
}

export async function getIntegrationSettings() {
  const requestUrl = `${API_URL}/private/catalyst/enterprises/integrations`;
  const json = await smartFetch(requestUrl);
  return json;
}

export async function updateIntegrationSettings(data: Record<string, any>) {
  try {
    const json = await smartFetch(
      `${API_URL}/private/catalyst/enterprises/integrations`,
      {
        method: "PUT",
        body: JSON.stringify(data),
      },
    );
    return json;
  } catch (e) {
    return handleApiError(e);
  }
}

export async function getIntegrationHealth() {
  try {
    return await smartFetch(
      `${API_URL}/private/catalyst/enterprises/integrations/health`,
    );
  } catch (e) {
    return handleApiError(e);
  }
}

export async function triggerIntegrationTest(params: {
  platform: string;
  taskId: string;
}) {
  try {
    return await smartFetch(
      `${API_URL}/private/catalyst/enterprises/integrations/test`,
      {
        method: "POST",
        body: JSON.stringify(params),
      },
    );
  } catch (e) {
    return handleApiError(e);
  }
}

export async function getIntegrationEventStatus(compositeTaskId: string) {
  try {
    return await smartFetch(
      `${API_URL}/private/catalyst/enterprises/integrations/events/${encodeURIComponent(compositeTaskId)}`,
    );
  } catch (e) {
    return handleApiError(e);
  }
}

export async function getRecentIntegrationTasks(platform: string) {
  return smartFetch(
    `${API_URL}/private/catalyst/enterprises/integrations/recent-tasks/${encodeURIComponent(platform)}`,
  );
}

export async function getAsanaProjects() {
  return smartFetch(
    `${API_URL}/private/catalyst/enterprises/integrations/asana/projects`,
  );
}

export async function registerAsanaWebhook(params: {
  projectGid: string;
  projectName: string;
}) {
  return smartFetch(
    `${API_URL}/private/catalyst/enterprises/integrations/asana/webhooks`,
    {
      method: "POST",
      body: JSON.stringify(params),
    },
  );
}

export async function removeAsanaWebhook(webhookId: string) {
  return smartFetch(
    `${API_URL}/private/catalyst/enterprises/integrations/asana/webhooks/${encodeURIComponent(webhookId)}`,
    { method: "DELETE" },
  );
}

// @ts-expect-error TS2339: `window` is strictly typed
window.UnsafeDeps = Object.assign({}, window.UnsafeDeps, {
  enterpriseApis: {
    createEnterprise,
    getEnterprises,
    updateEnterpriseSettings,
  },
});
